import { useState } from 'react';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';

/**
 * Signs the current user out, surfacing failures as a toast and exposing the
 * in-flight state for buttons to render a loading/disabled state.
 */
export function useSignOut() {
  const { logout } = useAuth();
  const [signingOut, setSigningOut] = useState(false);

  const signOut = async () => {
    try {
      setSigningOut(true);
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Failed to sign out. Please try again.');
    } finally {
      setSigningOut(false);
    }
  };

  return { signOut, signingOut };
}
